module.exports = __webpack_public_path__ + "img/level-3.8e7c42f8.png";